import { useLocation } from 'react-router-dom';

export const useEntityParams = () => {
    const { pathname } = useLocation();
    const [, entityType, entityId] = pathname.split('/');
    return { entityType, entityId };
};
